export default __webpack_public_path__ + "static/media/Markers_Yellow Marker - Boat.4acbe149.svg";